import React, { Component } from 'react';
import './partnerDetailsBanner.scss';
import { Link } from "react-scroll";
import { Link as LinkRouter } from 'react-router-dom'

import ArrowLeft from '../../../shared/assets/images/partnerDetails/arrow-left.svg'

class PartnerDetailsBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        const partner = this.props && this.props.contacts && this.props.contacts.length ? this.props.contacts[0].partner : '';

        return (
            <div className="PartnerDetailsBanner">
                <div className="container">
                    <div className="row ctm-all-shops-link">
                        <div className="col-12 d-flex">
                            <img src={ArrowLeft} alt="ArrowLeft" />
                            <span>

                                <LinkRouter to="/partners">Все магазины</LinkRouter>
                            </span>
                        </div>
                    </div>
                    <div className="row ctm-title-text-container">
                        <div className="col-12">
                            <div className="ctm-title">
                                Покупайте в
                                {this.props.windowWidth < 768 ? <br /> : " "}
                                рассрочку в «{partner}»
                            </div>
                            <div className="ctm-text-one">
                                Вы можете купить товары
                                {this.props.windowWidth < 768 ? <br /> : " "}
                                или услуги в рассрочку до 24 месяцев <br/> у различных партнеров в Душанбе и Худжанде
                            </div>
                            {/* <div className="ctm-text-two">
                                На покупку до 4 000 сомони
                                {this.props.windowWidth < 768 ? <br /> : " "}
                                справка о зарплате не нужна
                            </div> */}
                            <div className="ctm-buy-btn-container">
                                <Link
                                    to={"ShopContactSalomCard"}
                                    // hashSpy={true}
                                    // spy={true}
                                    smooth={true}
                                >
                                    <button className="btn btn-success">
                                        Как купить
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PartnerDetailsBanner;